<div class="loading-spinner loading-spinner__{{ size }}"></div>
